import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import FormInput from 'components/forms/FormInput';

class ItemSurcharge extends React.Component {
  updateMainEntity = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  render() {
    const {
      intl: { messages },
      webApp,
      entity,
      updateEntity,
      disabled,
    } = this.props;

    return (
      <>
        <div className="panel panel-transparent">
          <div className="panel-body">
            <p>Price-Calculation</p>
            <div className="form-group-attached">
              <FormInput
                label={messages.surcharge}
                name="surcharge"
                value={entity.getSurcharge()}
                meta={entity.getSurchargeMetaInformation()}
                validation={entity.getSurchargeValidationResult()}
                onChange={this.updateMainEntity}
                disabled={disabled}
                type="number"
                min="0"
                step={0.01}
                prefixAddon="%"
              />
              <FormInput
                label={messages.base_surcharge}
                name="baseSurcharge"
                value={entity.getBaseSurcharge()}
                meta={entity.getBaseSurchargeMetaInformation()}
                validation={entity.getBaseSurchargeValidationResult()}
                onChange={this.updateMainEntity}
                disabled={disabled}
                type="number"
                min="0"
                step={0.01}
                prefixAddon={webApp.currencySymbol}
              />
              <FormInput
                label={messages.max_surcharge}
                name="maxSurcharge"
                value={entity.getMaxSurcharge()}
                meta={entity.getMaxSurchargeMetaInformation()}
                validation={entity.getMaxSurchargeValidationResult()}
                onChange={this.updateMainEntity}
                disabled={disabled}
                type="number"
                min="0"
                step={0.01}
                prefixAddon={webApp.currencySymbol}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
  };
};

export default injectIntl(connect(mapStateToProps)(ItemSurcharge));
